import loadable from '@loadable/component';
// The key insight: Don't use fallbacks during SSR at all
// Instead, directly import the component for SSR
const GalleryBreadCrumbs =
    typeof window === 'undefined'
        ? // Server-side: import directly (synchronously)
          // eslint-disable-next-line import/no-dynamic-require
          require('./GalleryBreadCrumbs').default
        : // Client-side: use loadable with fallback
          loadable(
              () =>
                  import(/* webpackChunkName: "GalleryBreadCrumbsChunks" */ './GalleryBreadCrumbs'),
              {
                  fallback: null,
              }
          );

export default GalleryBreadCrumbs;
